// extracted by mini-css-extract-plugin
export default {"content":"content--hYWlC","primaryTitle":"primaryTitle--iMSYO"};